export class AdresseIP {
    
  constructor() {}

  getAdresseIP() {
    return "/diplome";
    
  }
}
